import React from 'react';
import { motion } from 'framer-motion';
import { Fireworks } from './Fireworks';
import { useCountdown } from '../hooks/useCountdown';
import { formatSchedule } from '../utils/schedule';
interface CountdownStageProps {
  eventName: string;
  startsAt: number;
  timeZone: string;
  /** Extra line under the clock, e.g. who is watching. */
  footnote?: string;
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  const text = String(value).padStart(2, '0');
  return <div className="flex flex-col items-center" data-id="element-67" data-mp="1ess8kjf9t6b">
      <div className="relative overflow-hidden rounded-xl border border-line bg-surface/80 px-3 py-2.5 sm:px-6 sm:py-4" data-id="element-68" data-mp="1gnf44e97vd1">
        <motion.span key={text} initial={{
        y: 10,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="block font-display text-[clamp(2.25rem,7vw,4.5rem)] leading-none tabular-nums text-white" data-id="element-69" data-mp="3jqz2tyd7nkin">
          {text}
        </motion.span>
      </div>
      <span className="mt-2 text-[0.65rem] font-semibold uppercase tracking-[0.24em] text-muted" data-id="element-70" data-mp="3roltuccrksz6">
        {label}
      </span>
    </div>;
}
export function CountdownStage({
  eventName,
  startsAt,
  timeZone,
  footnote
}: CountdownStageProps) {
  const remaining = useCountdown(startsAt);
  const showDays = remaining.days > 0;
  return <div className="relative flex min-w-0 flex-1 flex-col items-center justify-center overflow-hidden px-4 py-12 text-center sm:px-10 sm:py-16" data-id="element-71" data-mp="3vppah12myt1g">
      <Fireworks data-id="element-72" data-mp="341dppxr2npyq" />

      <div className="relative" data-id="element-73" data-mp="341x7negq2ecr">
        <p className="text-[0.7rem] font-semibold uppercase tracking-[0.28em] text-gold" data-id="element-74" data-mp="33yj7mcvj6h8h">
          Starting soon
        </p>
        <h2 className="mt-4 break-words font-display text-[clamp(2rem,6vw,3.75rem)] leading-tight text-white" data-id="element-75" data-mp="3d0iliwb91577">
          {eventName}
        </h2>

        <div className="mt-8 flex items-start justify-center gap-2 sm:mt-10 sm:gap-5" role="timer" aria-live="off" data-id="element-76" data-mp="2p9n0ci1at88x">
          {showDays && <Unit value={remaining.days} label="Days" data-id="element-77" data-mp="o8708uzmqni9" />}
          <Unit value={remaining.hours} label="Hours" data-id="element-78" data-mp="o7dxe53ski5e" />
          <Unit value={remaining.minutes} label="Minutes" data-id="element-79" data-mp="t70bshvcw4fs" />
          <Unit value={remaining.seconds} label="Seconds" data-id="element-80" data-mp="xza1pxwh14i2" />
        </div>

        <p className="mt-9 text-sm text-body" data-id="element-81" data-mp="y1e245v5vldl">{formatSchedule(startsAt, timeZone)}</p>
        <p className="mt-1 text-xs text-muted" data-id="element-82" data-mp="12xblkl1q17ul">
          The draw begins automatically when the countdown reaches zero.
        </p>
        {footnote && <p className="mt-5 text-sm text-muted" data-id="element-83" data-mp="a8xjnu7ihrdr">{footnote}</p>}
      </div>
    </div>;
}